import React, { useState, useEffect, useContext, forwardRef } from "react"
import { Table, Form, Button, Offcanvas } from "react-bootstrap"
import "./ListadoCohortes.css"
import Loading from "../Utils/Loading"
import UAI from "../UAI"
import AtributoModal from "../Utils/AtributoModal"
import ImportarAtributos from "./ImportarAtributos"
import { UsuarioContext } from "../Context/Usuario"
import EditarCohorteModal from "./EditarCohorteModal"
import log from "loglevel"
import MaterialTable from "material-table"

import AddBox from "@material-ui/icons/AddBox"
import ArrowDownward from "@material-ui/icons/ArrowDownward"
import Check from "@material-ui/icons/Check"
import ChevronLeft from "@material-ui/icons/ChevronLeft"
import ChevronRight from "@material-ui/icons/ChevronRight"
import Clear from "@material-ui/icons/Clear"
import Settings from "@material-ui/icons/Settings"
import DeleteOutline from "@material-ui/icons/DeleteOutline"
import Edit from "@material-ui/icons/Edit"
import FilterList from "@material-ui/icons/FilterList"
import FirstPage from "@material-ui/icons/FirstPage"
import LastPage from "@material-ui/icons/LastPage"
import Remove from "@material-ui/icons/Remove"
import SaveAlt from "@material-ui/icons/SaveAlt"
import Search from "@material-ui/icons/Search"
import ViewColumn from "@material-ui/icons/ViewColumn"

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
}

const ListadoCohortesUI = (props) => {
  const { usuario } = useContext(UsuarioContext)

  const [isOpenImportar, setIsOpenImportar] = useState(false)
  const [isOpenEditarEnLinea, setIsOpenEditarEnLinea] = useState(false)
  const [isOpenAtributoModal, setIsOpenAtributoModal] = useState(false)
  const [cohortes, setCohortes] = useState(null)
  const [showSettings, setShowSettings] = useState(false)
  const [selectedCohorte, setSelectedCohorte] = useState(null)
  const [selectedField, setSelectedField] = useState(null)
  const [multiselectCohortes, setMultiselectCohortes] = useState([])
  const [columns, setColumns] = useState(null)

  const guardarImportar = (cohorteOrigenId, atributos, cohorteDestinoId) => {
    setLoadingImportar(cohorteDestinoId)
    console.log(
      "Importando desde cohorte " + cohorteOrigenId + " a " + cohorteDestinoId
    )
    let cohorteOrigen = props.cohortes[cohorteOrigenId]
    if (cohorteOrigen === undefined) {
      alert("Error! No tenemos datos que importar! Cohorte:" + cohorteOrigenId)
      setLoadingImportar(null)
      return
    }
    let atributosValores = []
    for (let idx in atributos) {
      let atr = atributos[idx]
      let valor = cohorteOrigen[atr]
      atributosValores.push({ Codigo: atr, Valor: valor })
    }
    UAI.actualizaAtributos(
      usuario.username,
      cohorteDestinoId,
      atributosValores,
      guardarImportarSuccess,
      guardarImportarError
    )
    cerrarImportar(null)
  }

  const guardarImportarSuccess = (result) => {
    setLoadingImportar(null)
    if (result.Solicitudes === undefined) {
      alert("Error importando valores de cohorte! Respuesta inválida.")
      return
    }
    var resultado = result.Solicitudes[0]
    if (
      resultado === undefined ||
      resultado.CamposPorActualizar === undefined ||
      resultado.CamposPorActualizar.length === 0 ||
      resultado.CohorteId === undefined ||
      resultado.CohorteId <= 0
    ) {
      console.log(resultado)
      alert("Error importando valores de cohorte! Respuesta incompleta!")
      return
    }
    if (resultado.Mensaje !== "Actualización correcta") {
      console.log(resultado)
      alert(
        "Error importando valores de cohorte! Error de datos! " +
          resultado.Mensaje
      )
      return
    }
    setCohortes((prevState) => {
      let cohortes = {}
      for (var idx in prevState.cohortes) {
        var cohorte = prevState.cohortes[idx]
        if (cohorte.id === resultado.CohorteId) {
          for (var idc in resultado.CamposPorActualizar) {
            var campo = resultado.CamposPorActualizar[idc]
            cohorte[campo.Codigo] = campo.Valor
          }
        }
        cohortes[cohorte.key] = cohorte
      }
      return { cohortes }
    })
  }

  const abrirModalAtributo = (cohorte, field) => {
    setSelectedCohorte(cohorte)
    setSelectedField(field)
    setIsOpenAtributoModal(true)
  }

  const guardarImportarError = (error) => {
    console.log(error)
    setLoadingImportar(null)
  }

  const cerrarImportar = (cohorte) => {
    setIsOpenImportar(false)
  }

  const cerrarEditarEnLinea = (cohorte) => {
    setIsOpenEditarEnLinea(false)
  }

  const cerrarEditarInfoGeneralEnLinea = () => {
    setIsOpenEditarInfoGeneralEnLinea(false)
  }

  useEffect(() => {
    log.debug("UseEffect cohortes!")
    if (!props.view) return
    log.debug(JSON.parse(JSON.stringify(props)))
    const filtroPeriodo = (cohorte) => {
      return cohorte.Periodo
    }

    const filtroPendientesVista = (cohorte) => {
      let _visible = false
      if (!cohorte.Periodo) {
        return false
      }
      props.view.fields.forEach((field) => {
        if (
          cohorte[field] === undefined ||
          cohorte[field] === null ||
          cohorte[field] === ""
        ) {
          _visible = true
          return
        }
      })
      return _visible
    }
    /**
     * Convierte Tipo desde Postula a types de Material UI
     *
     * MaterialUI types: "string","boolean","numeric","date","datetime","time","currency"
     * @param {string} tipo nombre del tipo de dato en Postula
     * @returns nombre del tipo de dato en MaterialUI
     */
    const materialTableType = (tipo) => {
      switch (tipo) {
        case "Texto":
          return "string"
        case "Booleano":
          return "boolean"
        case "Numérico":
          return "numeric"
        case "Selector":
          return "string"
        case "Fecha":
          return "date"
        case "Texto Grande":
          return "string"
        case "Json":
          return "string"
        case "Html":
          return "string"
        case "Selector Múltiple":
          return "string"
        case "Especial":
          return "string"
        case "Archivo":
          return "string"
      }
      return "string"
    }

    const renderDatePostula = (cohorte, codigo) => {
      let val = null
      try {
        val = new Date(Date.parse(cohorte[codigo]))
      } catch (e) {
        val = null
      }
      if (isNaN(val)) {
        val = null
      }
      if (val && typeof val === "object") {
        val = val.toLocaleDateString("es-CL", {
          month: "2-digit",
          year: "2-digit",
          day: "2-digit",
        })
        return val
      } else {
        return cohorte[codigo]
      }
    }

    //Cargaremos los cohortes del usuario a partir de los parámetros de Unidad de Venta
    let cohortesusuario = null
    let facultad = props.tabs.facultad
    let unidadventa = props.tabs.unidadventa
    if (unidadventa && facultad) {
      if (facultad === "resumen") {
        facultad = Object.keys(usuario.facultades)[0]
      }
      cohortesusuario = usuario.unidadesventa[unidadventa].facultades[facultad]
      if (!cohortesusuario) {
        throw new Error(
          "Datos inválidos! No existen cohortes para esta vista:" +
            facultad +
            "-" +
            unidadventa
        )
      }
    } else {
      cohortesusuario = usuario.cohortes
    }
    // Solo mostramos los cohortes que son del período
    let _filtro = props.filtroVista ? filtroPendientesVista : filtroPeriodo
    let listadoCohortes = Object.values(cohortesusuario).filter(_filtro)
    if (props.view.filtroCohortes) {
      listadoCohortes = Object.values(listadoCohortes).filter(
        props.view.filtroCohortes
      )
    }
    let filtroBorradores = props.borradores || props.view.borradores
    if (filtroBorradores) {
      listadoCohortes = listadoCohortes.filter((coh) => {
        return (
          (filtroBorradores === "noborradores" && !coh.esborrador) ||
          (filtroBorradores === "soloborradores" && coh.esborrador) ||
          filtroBorradores === "todo"
        )
      })
    }
    // Si la vista tiene un filtro de exclusión, lo aplicamos
    if (props.view.excluir) {
      let prev = listadoCohortes.length
      listadoCohortes = listadoCohortes.filter((coh) => {
        return props.view.excluir.grados.indexOf(coh.gradoid) < 0
      })
      console.log(
        "Filtro de vista aplicado " + prev + " -> " + listadoCohortes.length
      )
    }
    // Filtramos por coordinadora admisión o de programa en caso de haber filtros
    log.debug(props.tabs.activeFilters)
    let index = props.tabs.facultad + "-" + props.tabs.unidadventa
    if (
      props.tabs.activeFilters &&
      props.tabs.activeFilters[index] &&
      props.tabs.activeFilters[index].coordinadorasadmision &&
      props.tabs.activeFilters[index].coordinadorasadmision.length > 0
    ) {
      listadoCohortes = listadoCohortes.filter((c) => {
        return (
          props.tabs.activeFilters[index].coordinadorasadmision.indexOf(
            c.usuario_coordinador_admision
          ) >= 0
        )
      })
    }
    // Ordenamos el listado de cohortes por año inicio, grado y nombre
    listadoCohortes.sort(function (a, b) {
      let sa =
        (a.esborrador ? "Z" : "A") +
        a.año_inicio +
        "-" +
        UAI.nombresGrados[a.gradoid] +
        "-" +
        a.nombre
      let sb =
        (b.esborrador ? "Z" : "A") +
        b.año_inicio +
        "-" +
        UAI.nombresGrados[b.gradoid] +
        "-" +
        b.nombre
      return sb.localeCompare(sa)
    })

    let _fields = JSON.parse(JSON.stringify(props.view.fields))
    if (_fields.indexOf("nombre") < 0) {
      _fields = ["programa_id", "nombre"].concat(_fields)
    }
    let ignorar = ["Booleano", "Fecha", "Html", "TextoGrande"]
    let _columns = _fields.reduce((prev, current) => {
      let atributo = usuario.atributos[current]
      log.debug(atributo)
      let col = {
        title: atributo.Nombre,
        field: atributo.Codigo,
        type: materialTableType(atributo.Tipo),
      }
      if (atributo.Codigo === "programa_id") {
        col.title = "ID"
        col.defaultSort = "asc"
        col.render = (rowData) => {
          return rowData.id > 0 ? rowData.id : "Borrador"
        }
        prev.push(col)
        return prev
      }
      if (atributo.display && ignorar.indexOf(atributo.Tipo) < 0) {
        col.render = (rowData) => {
          return atributo.display(rowData, usuario.periodo, undefined, usuario)
        }
      }
      if (atributo.Tipo === "Fecha") {
        col.render = (rowData) => {
          return renderDatePostula(rowData, atributo.Codigo)
        }
      }
      if (
        atributo.Tipo === "Html" ||
        atributo.Tipo === "TextoGrande" ||
        atributo.Tipo === "Texto"
      ) {
        col.render = (rowData) => {
          let html = rowData[atributo.Codigo]
          if (!html) {
            return <></>
          }
          if (html.length > 30)
            return (
              <div
                className="divVerMas"
                onClick={() => {
                  abrirModalAtributo(rowData, atributo)
                }}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: rowData[atributo.Codigo].slice(0, 30) + "...",
                  }}
                ></div>
              </div>
            )
          return html
        }
      }
      if (atributo.Codigo === "nombre") {
        col.render = (rowData) => (
          <div>
            <Link to={"/cohorte/" + rowData.id}>{rowData.nombre}</Link>
          </div>
        )
      }

      prev.push(col)
      return prev
    }, [])
    setCohortes(listadoCohortes)
    setColumns(_columns)
  }, [
    props.tabs.activeFilters,
    props.view,
    props.tabs.facultad,
    props.tabs.unidadventa,
    usuario,
  ])

  if (!cohortes || !columns) {
    return <Loading />
  }

  log.debug(columns)
  log.debug(cohortes)

  return (
    <>
      {props.mostrarTotal && <p>{cohortes.length} cohortes encontrados</p>}
      <MaterialTable
        columns={columns}
        data={cohortes}
        title={"Total: " + cohortes.length}
        icons={tableIcons}
        options={{
          paging: false,
          selection: true,
        }}
        localization={{ "toolbar.searchPlaceholder": "Buscar" }}
        actions={[
          {
            icon: Edit,
            tooltip: "Editar seleccionados",
            onClick: (event, rowData) => {
              log.debug(event)
              log.debug(rowData)
              let ids = rowData.reduce((prev, current) => {
                prev.push(current.id)
                return prev
              }, [])
              setMultiselectCohortes(ids)
              setIsOpenEditarEnLinea(true)
            },
          },
          {
            icon: Settings,
            tooltip: "Configurar reporte",
            isFreeAction: true,
            onClick: (event, rowData) => {
              setShowSettings(true)
            },
          },
        ]}
      />
      <Offcanvas
        show={showSettings}
        placement="end"
        onHide={() => {
          setShowSettings(false)
        }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Configuración</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="h4">Atributos visibles</div>
          <ul>
            {props.view.fields.map((f) => {
              let a = usuario.atributos[f]
              return <li key={f}>{a.Nombre}</li>
            })}
          </ul>
          Agregar atributo
          <Form.Select>
            <option value="">Seleccione un atributo</option>
            {Object.values(usuario.atributos).map((a) => (
              <option key={a.Codigo} value={a.Codigo}>
                {a.Nombre}
              </option>
            ))}
          </Form.Select>
        </Offcanvas.Body>
      </Offcanvas>
      <EditarCohorteModal
        isOpen={isOpenEditarEnLinea}
        cohortes={multiselectCohortes}
        cohorte={selectedCohorte}
        cerrar={cerrarEditarEnLinea}
        view={props.view}
      />
      <AtributoModal
        cohorte={selectedCohorte}
        field={selectedField}
        isOpen={isOpenAtributoModal}
        readOnly={selectedField && selectedField.editable}
        Cerrar={() => {
          setIsOpenAtributoModal(false)
        }}
      />
    </>
  )
}

export default ListadoCohortesUI
